module.exports = __webpack_public_path__ + "static/scrabblista-desktop-3.1baa4b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/project/scrabblista/img/scrabblista-desktop-3.png
// module id = 624
// module chunks = 230197332751855